export enum DateFormat {
  DateWithTime = 'DD.MM.YY HH:mm:ss',
}
